import React from 'react';
import NavbarList from './NavbarList';

const CSS = require('./MobileList.less');

interface MobileListProps {
  onClick: () => void;
}

function MobileList({ onClick }: MobileListProps) {
  return (
    <div className={CSS.MobileList}>
      <NavbarList onClick={onClick} isMobile/>
    </div>
  );
}

export default MobileList;
